import vertexShaderSrc from './vertex.vert';
import fragmentShaderSrc from './fragment.frag';
import * as PIXI from 'pixi.js';
import { APP_WIDTH, APP_HEIGHT } from '../../utils/commonUtils';

export default class WavesShader extends PIXI.Shader {
    constructor() {
        const glProgram = PIXI.GlProgram.from({
            vertex: vertexShaderSrc,
            fragment: fragmentShaderSrc,
            name: 'waves_shader',
            preferredFragmentPrecision: 'highp',
        });

        super({
            glProgram,
            resources: {
                timeUniforms: {
                    _time: { value: 0.0, type: 'f32' },
                },
                commonUniforms: {
                    _inputSize: { value: [APP_WIDTH, APP_HEIGHT], type: 'vec2<f32>' },
                },
            }
        });
    }
}